function goContact(){
  // window.open("https://s.milinzone.com/?scene=71700")
  // location.href = 'weixin://dl/business/?t=tdKaaAMEuXl'
  let status = getRunState();
  if(status.isWeixin){
    
  } else {
    window.open("https://mlz2.cn/iEs")
  }
}

// 判定所处环境 逻辑
function getRunState(){
  var userAgent = navigator.userAgent.toLowerCase();
  var isWXWork = userAgent.match(/wxwork/i) == 'wxwork'
  var isWeixin = !isWXWork && userAgent.match(/micromessenger/i) == 'micromessenger'; // 微信
  var isWribo = userAgent.match(/WeiBo/i) == 'weibo' ? true : false; // 微博
  var isMobile = false;
  var isDesktop = false;
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)) {
    isMobile = true;
  } else {
    isDesktop = true;
  }

  return {
    isWeixin,
    isWribo,
    isMobile,
    isDesktop
  }
}
export default {
  goContact,
  getRunState
}